import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { useOsanoScript } from '@trinity/chat-components/hooks/useOsanoScript';
import { NavBar } from '@/components/Nav/NavBar';
import { FaqSwitchProvider } from '@/contexts/FaqSwitchContext';
import { DocumentHelmet } from './Helmet';

const OSANO_SCRIPT_SRC = 'https://cmp.osano.com/CkGgcA5Jms/707815f6-f954-4c8d-8f34-83c380da2aa3/osano.js';

export const Layout = () => {
  useOsanoScript({ visible: false, src: OSANO_SCRIPT_SRC });

  return (
    <FaqSwitchProvider>
      <DocumentHelmet />
      <NavBar />
      <MainContent>
        <Outlet />
      </MainContent>
      <Toast />
    </FaqSwitchProvider>
  );
};

const MainContent = styled.main({
  paddingTop: `var(--navbar-height)`,
});
